import { Button } from 'shared/components/ui';
import React from 'react';
import './NotificacionesPanel.css';

const NotificacionesPanel = ({ notificaciones, mensaje, setMensaje, onEnviarMensaje, isAdmin }) => {
  return (
    <div className="notificaciones-panel">
      <div className="notificaciones-header">
        <h3>Mensajes</h3>
      </div>
      
      <div className="notificaciones-lista">
        {notificaciones.length === 0 ? (
          <div className="notificacion-vacia">
            No hay notificaciones
          </div>
        ) : (
          notificaciones.map((notif, index) => (
            <div key={index} className={`notificacion-item ${notif.lectura ? '' : 'no-leida'}`}>
              <div className="notificacion-header">
                <strong>{notif.envia}</strong>
                <span className="notificacion-fecha">
                  {new Date(notif.fechaCreacion).toLocaleString()}
                </span>
              </div>
              <div className="notificacion-mensaje">
                {notif.mensaje}
              </div>
            </div>
          ))
        )}
      </div>

      <div className="notificaciones-responder">
        <h4>{isAdmin ? 'Enviar mensaje al técnico' : 'Enviar mensaje al administrador'}</h4>
        <textarea
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          placeholder={isAdmin ? "Escribir mensaje al técnico..." : "Escribir mensaje al administrador..."}
          rows="3"
          className="form-control"
        />
        <Button
          onClick={onEnviarMensaje} 
          className="btn btn-primary"
          disabled={!mensaje.trim()}
        >
          Enviar Mensaje
        </Button>
      </div>
    </div>
  );
};

export default NotificacionesPanel;
